import addMount from "../../core/addMount";
import SeriesEntry from "./Series.entry";

addMount({
  appName: "series",
  app: SeriesEntry
});
